(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moodly-product"]) return;
  try {
    
(function(){
  function init(root){
    var bar=root.querySelector('[data-mdl-sticky]'),add=root.querySelector('[data-add]'),price=root.querySelector('[data-price]'),info=root.querySelector('.mdl-pdp__info');
    if(!bar||!add||!info||!('IntersectionObserver' in window))return;
    var btn=bar.querySelector('[data-sticky-add]'),sp=bar.querySelector('[data-sticky-price]');
    function sync(){
      if(sp&&price)sp.textContent=price.textContent;
      btn.disabled=add.disabled;
      btn.textContent=add.textContent.trim();
    }
    sync();
    new MutationObserver(sync).observe(info,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['disabled']});
    var past=false,end=false;
    function show(){bar.classList.toggle('is-on',past&&!end);}
    new IntersectionObserver(function(es){
      var e=es[es.length-1];
      past=!e.isIntersecting&&e.boundingClientRect.top<0;show();
    }).observe(add);
    function atEnd(){
      var d=document.documentElement;
      end=window.innerHeight+window.pageYOffset>=d.scrollHeight-96;show();
    }
    window.addEventListener('scroll',atEnd,{passive:true});atEnd();
    btn.addEventListener('click',function(){if(!add.disabled)add.click();});
  }
  document.querySelectorAll('[data-mdl-product]').forEach(init);
})();

  } catch(e) { console.error(e); }
})();
})();
